import type { DistanceUnit } from "@/models/siteUnit.types";

/**
 * UI display unit. Metric sites go through cm, which is specific to this feature;
 * feet and US survey feet both render as `ft` while keeping separate conversions.
 */
export const spreadingCompactionDisplayUnits = {
	CENTIMETERS: "cm",
	FEET: "ft",
} as const;

export type SpreadingCompactionDisplayUnit =
	(typeof spreadingCompactionDisplayUnits)[keyof typeof spreadingCompactionDisplayUnits];

/**
 * Display settings for parameter input and result labels.
 * Distance labels and unit name keys come from `useUnitDisplay`, not from here.
 */
export interface SpreadingCompactionUnitConfig {
	distanceUnit: DistanceUnit;
	displayUnit: SpreadingCompactionDisplayUnit;
	/** Decimals for display, file names and input granularity. */
	displayDecimals: number;
	/** Default compaction surface spacing, in display unit. */
	defaultSpacingDisplay: number;
	/** Default slope shoulder offset, in display unit. Must be <= 0. */
	defaultSlopeShoulderOffsetDisplay: number;
}
